// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"5632592c2934920d9ba1","532":"bd58cb6bae701541dc29","691":"fc9d3d16ad751986a1c4"}[chunkId] + ".js";
};